import { Component, Input } from "@angular/core";

@Component({
  selector: "toolbox-example-tab-menu",
  templateUrl: "./example-tab-menu.component.html",
  styleUrls: ["./example-tab-menu.component.scss"],
})
export class ExampleTabMenuComponent {
  @Input() orientation: string;
}
